import {
    getAxios,
} from './axios'

export function getFooter() {
    let axios = getAxios();

    // axios.interceptors.response.use(profileResponseInterceptor);

    return axios.request({
        url: '/footer/',
        method: 'get'
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/footer.js